"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Translates content in English or Spanish based on HTML lang attribute
 * @param {Object} contentObject a content object that has "ES" and "EN" keys,
 * for example: { EN: 'hello world', ES: 'Hola Mundo' }
 * @returns {string} translated text string
 */
var useTranslate = function useTranslate(content) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      errorString = _useState2[0],
      setErrorString = _useState2[1];

  if (!content.EN && !content.ES) {
    throw new Error("useTranslate() hook requires English and Spanish translations!\n\nPlease provide an object shaped like this:\nconst translatedString = useTranslate({\n  // EN: '\uD83C\uDDFA\uD83C\uDDF8 English text',\n  // ES: '\uD83C\uDDEA\uD83C\uDDF8 Spanish text',\n});\n\nThanks! / \xA1Gracias!");
  }

  if (!content.EN) {
    throw new Error("useTranslate() hook requires an English translation!\nProvided: {ES: \"".concat(content.ES, "\"}"));
  }

  if (!content.ES) {
    throw new Error("useTranslate() hook requires an Spanish translation!\nProvided: {EN: \"".concat(content.EN, "\"}"));
  }

  (0, _react.useLayoutEffect)(function () {
    var setString = function setString() {
      switch (document.documentElement.lang) {
        case 'en':
          setErrorString(content.EN);
          break;

        case 'es':
          setErrorString(content.ES);
          break;

        default:
          setErrorString(content.EN);
          break;
      }
    }; // Creates new MutationsObserver that looks for html attribute changes


    var langObserver = new MutationObserver(function (M) {
      return M.forEach(function (m) {
        return m.type === 'attributes' && setString();
      });
    }); // Looks for attribute changes on document element

    langObserver.observe(document.documentElement, {
      attributes: true // configure it to listen to attribute changes

    });
    setString(); // cleanup, disconnects the observer

    return function () {
      langObserver.disconnect();
    };
  }, dependencies);
  return errorString;
};

var _default = useTranslate;
exports.default = _default;